import { ListEntity } from "models/list-entity";
import { ListEntityField } from "models/list-entity-field";
import { FunctionComponent, useEffect, useState } from "react";
import { userDoGetListEntityFields } from "services/user/list-entity-field";
import ListEntityFieldSingleForm from "./single-form";
import { useListEntities } from "stores/hooks/list-entities";
import { useNavigate } from "react-router";
import { FormValues, fromFromValues } from "lib/form";
import {
  userDoGetEntityCollections,
  userDoPatchEntityCollection,
  userDoPostEntityCollection,
} from "services/user/entity-collection";
import { EntityCollection } from "models/list-user-entity-collection";
import { EntityCollectionValue } from "models/list-user-entity-collection-value";
import { List } from "models/list";

interface UserListEntitySingleProps {
  list: List;
  listEntity: ListEntity;
}

const ListEntitySingle: FunctionComponent<UserListEntitySingleProps> = ({
  list,
  listEntity,
}) => {
  const navigate = useNavigate();
  const entities = useListEntities();
  const [listEntityFields, toggleListEntityFields] = useState<
    ListEntityField[] | undefined
  >(undefined);
  const [entityCollection, toggleEntityCollection] = useState<
    EntityCollection | undefined
  >(undefined);

  useEffect(() => {
    const fetch = async () => {
      const listEntityFields = await userDoGetListEntityFields(
        list.uuid,
        listEntity.uuid,
      );
      toggleListEntityFields(listEntityFields);

      // fetch entityCollections and create a new one, if non exists
      const entityCollections = await userDoGetEntityCollections(
        listEntity.uuid,
      );
      let ec = entityCollections[0];
      if (!ec) {
        ec = await userDoPostEntityCollection(listEntity.uuid, []);
      }
      toggleEntityCollection(ec);
    };
    fetch();
  }, []);

  if (!list || !listEntityFields || !entityCollection) {
    return null;
  }

  const { entityCollectionValues = [] } = entityCollection;
  const index = entities.findIndex((ent) => ent.uuid === listEntity.uuid);

  const onSubmit = async (formValues: FormValues) => {
    // since the values has uuid-answer pairs, make into EntityFieldValue array
    const newEntityCollectionValues = fromFromValues(
      entityCollectionValues,
      formValues,
    );

    await userDoPatchEntityCollection(listEntity.uuid, entityCollection.uuid, {
      ...entityCollection,
      entityCollectionValues:
        newEntityCollectionValues as EntityCollectionValue[],
    });

    // from last entity we go to summary
    if (listEntity.order === entities.length - 1) {
      navigate(`/user/list/${list.uuid}/summary`);
    } else {
      const nextEntity = entities[index + 1];
      navigate(`/user/list/${list.uuid}/entity/${nextEntity.uuid}`);
    }
  };

  const onPrevious = async () => {
    // action nav
    // from first entity we go to obligation (if enabled)
    if (listEntity.order === 0) {
      navigate(`/user/list/${list.uuid}/obligation`);
    } else {
      const nextEntity = entities[index - 1];
      navigate(`/user/list/${list.uuid}/entity/${nextEntity.uuid}`);
    }
  };

  return (
    <ListEntityFieldSingleForm
      list={list}
      listEntity={listEntity}
      onSubmit={onSubmit}
      onPrevious={onPrevious}
      listEntityFields={listEntityFields}
      entityCollectionValues={entityCollectionValues}
    />
  );
};

export default ListEntitySingle;
